export default __webpack_public_path__ + "static/2021_2022_WVS INDIA CONSOLIDATED ACCOUNTS-41cd9253169c63eebe51fb4a8eac7dcb.pdf";